module.exports = __webpack_public_path__ + "img/рз_1.49026c5d.png";